import PermissionService from '@Services/PermissionService';
import React, { lazy } from 'react';

const ActiveDealsList = lazy(() => import('./components/ActiveDealsList/ActiveDealsList'));
const HistoryDealsList = lazy(() => import('./components/HistoryDealsList/HistoryDealsList'));

export const dealsConfig = [
	{
		auth: true,
		component: <ActiveDealsList/>,
		name: 'deals_active',
		path: '/deals/active',
		pm: (pm) => PermissionService(pm).getActiveDeals(),
	},
	{
		auth: true,
		component: <HistoryDealsList/>,
		name: 'deals_history',
		path: '/deals/history',
		pm: (pm) => PermissionService(pm).getCloseDeals(),
	},
]